import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Image from 'components/Image';
import Loading from 'components/Loading';
import Buttonlet from 'components/Buttonlet';

import {
  dismissNewsItem,
} from 'actions/news';


import moment from 'moment';

class News extends React.Component {
  /**
   * dismiss
   * @return {undefined}
   */
  dismiss(id) {
    const { dispatch } = this.props;
    dispatch(dismissNewsItem(id));
  }

  render() {
    const { newsItem, active } = this.props;

    if (!active) {
      return null;
    }

    if (!newsItem) {
      return (<Loading spinner />);
    }

    const date = moment(newsItem.atDateTime).format('DD/MM/YYYY');
    return (
      <div className="news">
        <Image icon={newsItem.image} type="small-icon" height={40} width={40} />
        <div className="news-body">
          <Buttonlet
            className="news__close-button"
            type="close"
            onClick={() => { this.dismiss(newsItem.id); }}
          />
          <div className="heading heading--2">
            {' '}
            {newsItem.heading}
            {' '}
          </div>
          <div className="news-topline">
            <div className="heading heading--4">{date}</div>
          </div>
          <p dangerouslySetInnerHTML={{ __html: newsItem.html }} />
        </div>

      </div>
    );
  }
}

News.displayName = 'News';

News.propTypes = {
  active: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  newsItem: PropTypes.shape({}),
};


const mapStateToProps = state => ({
  newsItem: state.news.newsItem,
  active: state.news.active,
});

export default withRouter(connect(mapStateToProps)(News));
